import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import axios from 'axios';
// Utility-Funktionen (ersetzt FitnessPlanService)
const getEmptyStatistics = () => ({
    totalWorkouts: 0,
    totalDuration: 0,
    dataPoints: 0,
    data: [],
    minDate: null
});
import firebase from 'firebase';
import { getStatistics, ensureMigrated } from '@/services/fitnessPlanApi';
import router from '@/router';
import {favouritesCollection, userPlaylistCollection, userInformationCollection, premiumPurchasesCollection, devicesCollection, receiptCollection} from '@/firebase/index.js';
import {version} from "../../package";

Vue.use(Vuex)

/** Vue Router 3 rejects push() for duplicate/cancelled navigations — not app bugs. */
function navigateTo(location) {
    return router.push(location).catch((err) => {
        if (!err) return;
        const name = err.name || '';
        if (
            name === 'NavigationDuplicated' ||
            name === 'NavigationCancelled' ||
            name === 'NavigationAborted' ||
            /Navigation cancelled from/i.test(err.message || '') ||
            /Navigation aborted from/i.test(err.message || '')
        ) {
            return;
        }
        throw err;
    });
}

function listItems(collection) {
    if (collection && Array.isArray(collection.items)) {
        return collection.items;
    }
    return [];
}

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    // Schließe fitnessPlan aus der Persistierung aus - wird vom Server geladen
    blacklist: ['fitnessPlan']
});

const SECONDS_PER_DAY = 86400;

export default new Vuex.Store({
    state: {
        articles: [],
        readArticleList: [],
        displayedMotivationTextList: [],
        workouts: [],
        challenges: [],
        playlists: [],
        exercises: [],
        homePageInfo: [],
        categories: [],
        sportsTypes: [],
        equipmentList: [],
        userEquipment: [],
        coaches: [],
        articleCategories: [],
        articleMediaTypes: [],
        apiUrl: "https://cms.sportlerplus.com/api/v2/",
        user: null,
        isAuthenticated: false,
        userEmailVerified: false,
        onboardingData: {},
        temporaryPlaylist: {},
        workoutSource: [],
        deviceToken: null,
        operatingSystem: null,
        installationId: null,
        premiumStatus: null,
        receiptData: null,
        soundEnabled: true,
        selectedFitnessPlanActivity: null,
        recentFitnessPlanActivities: [],
        recentTrainingActivities: [],
        fitnessPlan: {},
        workoutIntensities: [{"id": 1, "name": "Leicht"}, {"id": 2, "name": "Mittel"}, {"id": 3, "name": "Schwer"}],
    },
    mutations: {
        clearMotivationTextAsDisplayed(state, uniqueChallengeId) {
            state.displayedMotivationTextList = state.displayedMotivationTextList.filter(text => text.uniqueChallengeId !== uniqueChallengeId);
        },
        setSoundEnabled(state, payload) {
            state.soundEnabled = payload;
        },
        setPremiumStatus(state, payload) {
            state.premiumStatus = payload;
        },
        setHomePageInfo(state, payload) {
            state.homePageInfo = payload;
        },
        setCategories(state, payload) {
            state.categories = payload;
        },
        setSportsTypes(state, payload) {
            state.sportsTypes = payload;
        },
        setEquipmentList(state, payload) {
            state.equipmentList = payload;
        },
        setCoaches(state, payload) {
            state.coaches = payload;
        },
        setArticles(state, payload) {
            state.articles = payload;
        },
        setWorkouts(state, payload) {
            state.workouts = payload;
        },
        setChallenges(state, payload) {
            state.challenges = payload;
        },
        setPlaylists(state, payload) {
            state.playlists = payload;
        },
        setExercises(state, payload) {
            state.exercises = payload;
        },
        setUser(state, payload) {
            state.user = payload;
        },
        setIsAuthenticated(state, payload) {
            state.isAuthenticated = payload;
        },
        setUserEmailVerified(state, payload) {
            state.userEmailVerified = payload;
        },
        setArticleMediaTypes(state, payload) {
            state.articleMediaTypes = payload;
        },
        setArticleCategories(state, payload) {
            state.articleCategories = payload;
        },
        updateOnboardingData(state, payload) {
            state.onboardingData = Object.assign(state.onboardingData, payload);
        },
        updateTemporaryPlaylist(state, payload) {
            state.temporaryPlaylist = Object.assign(state.temporaryPlaylist, payload);
        },
        initTemporaryPlaylist(state, payload) {
            state.temporaryPlaylist = payload;
        },
        initWorkoutSource(state, payload) {
            state.workoutSource = payload;
        },
        setDeviceToken(state, token) {
            state.deviceToken = token;
        },
        setReceiptData(state, receiptData) {
            state.receiptData = receiptData
        },
        setOperatingSystem(state, system) {
            state.operatingSystem = system;
        },
        setInstallationId(state, installationId) {
            state.installationId = installationId;
        },
        setUserEquipment(state, list) {
            state.userEquipment = list;
        },
        markArticleAsRead(state, article_id) {
            if (state.readArticleList.indexOf(article_id) != -1) { return; }
            state.readArticleList.push(article_id);
        },
        markMotivationTextAsDisplayed(state, mark) {
            if (state.displayedMotivationTextList.indexOf(mark) !== -1) { return; }
            state.displayedMotivationTextList.push(mark);
        },
        setFitnessPlan(state, payload) {
            state.fitnessPlan = payload;
        },
        setSelectedFitnessPlanActivity(state, activity) {
            state.selectedFitnessPlanActivity = activity;
        },
        addRecentFitnessPlanActivity(state, activity) {
            if (!state.recentFitnessPlanActivities.find(n => {
                if (n.meta === undefined && activity.meta === undefined) {
                    return n.id == activity.id;
                }
                else if (n.meta && activity.meta) {
                    return n.id == activity.id && n.meta.type == activity.meta.type;
                }
                return false;
            })) {
                state.recentFitnessPlanActivities.push(activity);
            }
            state.recentFitnessPlanActivities = state.recentFitnessPlanActivities.slice(-5);
        },
        // TODO: should be removed
        addRecentTrainingActivity(state, activity) {
            if (!state.recentTrainingActivities.find(n => {
                if (n.meta === undefined && activity.meta === undefined) {
                    return n.id == activity.id;
                }
                else if (n.meta && activity.meta) {
                    return n.id == activity.id && n.meta.type == activity.meta.type;
                }
                return false;
            })) {
                state.recentTrainingActivities.push(activity);
            }
            state.recentTrainingActivities = state.recentTrainingActivities.slice(-5);
        }
    },
    actions: {
        updateOnboardingData({ commit }, new_data) {
            commit('updateOnboardingData', new_data);
        },
        updateTemporaryPlaylist({ commit }, new_data) {
            commit('updateTemporaryPlaylist', new_data);
        },
        initTemporaryPlaylist({ commit }, new_data) {
            commit('initTemporaryPlaylist', new_data);
        },
        initWorkoutSource({ commit }, new_data) {
            commit('initWorkoutSource', new_data);
        },
        updateUserEquipment({ commit }, new_data) {
            commit('setUserEquipment', new_data);
        },
        async saveUserPlaylist( {state}, playlist) {
            const userId = state.user.user.uid;

            playlist.userId = userId;
            playlist.version = (playlist.version || 0) + 1;
            playlist.userDisplayName = state.user.user.displayName;

            if (playlist.uid) {
                await userPlaylistCollection.doc(playlist.uid).set(playlist);
            }
            else {
                playlist.creationDate = new Date().toISOString();
                await userPlaylistCollection.add(playlist);
            }
        },
        async deleteUserPlaylist( {state}, playlist) {
            const userId = state.user.user.uid;

            if (playlist.uid && (playlist.userId === userId)) {
                await userPlaylistCollection.doc(playlist.uid).delete();
            }
        },
        async fetchAllUserPlaylists( {state} ) {
            const userId = state.user && state.user.user && state.user.user.uid;
            if (!userId) {
                return [];
            }
            var result = [];
            var shared_documents = []
            var query = userPlaylistCollection.where("userId", "==", userId);
            await query.get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    // if _originalPlaylistUid present (shared workout), retrieve original document laster
                    // doc.data() is never undefined for query doc snapshots
                    var workout_document = doc.data();
                    workout_document = Object.assign({ uid: doc.id, meta: { type: "Custom/UserPlaylist" }, creationDate: doc.creationDate || "1978-01-01T00:00:00" }, workout_document);
                    if (workout_document._originalPlaylistUid) {
                        shared_documents.push(workout_document);
                        return;
                    }
                    result.push(workout_document);
                });
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
            });

            for (var i = 0; i < shared_documents.length; i++) {
                try {
                    var masterSnapshot = await userPlaylistCollection.doc(shared_documents[i]._originalPlaylistUid).get();
                    var master_document = masterSnapshot.data();

                    if (master_document) {
                        shared_documents[i].name = master_document.name;
                        shared_documents[i].items = master_document.items;
                        shared_documents[i].shuffle = master_document.shuffle;
                    }
                    result.push(shared_documents[i]);
                } catch (error) {
                    // Shared originals may be missing or blocked by Firestore rules
                    console.warn('Could not load shared playlist original', error);
                    result.push(shared_documents[i]);
                }
            }

            return result;
        },
        async fetchUserPlaylist( {state}, uid ) {
            const userId = state.user.user.uid;
            let playlistDoc = await userPlaylistCollection.doc(uid).get();
            if (playlistDoc.data().userId == userId) {
                var document_data = playlistDoc.data();
                if (document_data._originalPlaylistUid) {
                    var master_document = await userPlaylistCollection.doc(document_data._originalPlaylistUid).get();
                    master_document = master_document.data();
                    if (master_document) {
                        document_data.name = master_document.name;
                        document_data.items = master_document.items;
                        document_data.shuffle = master_document.shuffle;
                        if (document_data.version != master_document.version) {
                            console.log("detected change in workout, saving newer version...");
                            document_data.version = master_document.version;
                            await userPlaylistCollection.doc(playlistDoc.id).set(document_data);
                        }
                    } else {
                        console.log("master document not available");
                    }
                }
                return Object.assign({ uid: playlistDoc.id }, document_data);
            }
            return { error: "no access"};
        },
        /* eslint-disable no-unused-vars */
        async fetchSharedPlaylist( {state}, uid ) {
            // todo: should implement a flag to check whether this playlist has actually been shared
            let playlistDoc = await userPlaylistCollection.doc(uid).get();
            return playlistDoc.data();
        },
        async fetchFitnessPlan({ state, commit }) {
            // VERALTET: Nur noch für Legacy-Kompatibilität - verwende Cloud Functions!
            console.warn('fetchFitnessPlan is deprecated - use Cloud Functions instead');
            
            const userId = state.user.user.uid;
            try {
                // Minimaler Direct-Access für Legacy-Views
                const response = await fetch(`https://storage.googleapis.com/sportler-plus.appspot.com/fitnessplan-${userId}.json`);
                if (response.ok) {
                    const plan = await response.json();
                    commit('setFitnessPlan', Object.freeze(plan));
                    return [plan];
                }
            } catch (error) {
                console.error('Legacy fetchFitnessPlan error:', error);
            }
            
            commit('setFitnessPlan', { items: [], startedChallenges: [], startedActivities: [] });
            return [{ items: [], startedChallenges: [], startedActivities: [] }];
        },
        async saveFitnessPlan({ state, commit }, fitnessPlan) {
            // VERALTET: Nur noch für Legacy-Kompatibilität - verwende Cloud Functions!
            console.warn('saveFitnessPlan is deprecated - use Cloud Functions instead');
            
            // Für Legacy-Kompatibilität: setze nur im Store
            commit('setFitnessPlan', Object.freeze(fitnessPlan));
            return fitnessPlan;
        },
        async fetchUserInformation( {state} ) {
            const userId = state.user && state.user.user && state.user.user.uid;
            if (!userId) {
                return [];
            }
            var result = [];
            var query = userInformationCollection.where("userId", "==", userId);
            await query.limit(1).get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    // doc.data() is never undefined for query doc snapshots
                    result.push(Object.assign({ uid: doc.id }, doc.data()));
                });
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
            });
            return result;
        },
        async saveUserInformation( {state}, userInformation) {
            const userId = state.user && state.user.user && state.user.user.uid;
            if (!userId || !userInformation) {
                console.warn('saveUserInformation skipped: missing user or payload');
                return;
            }

            userInformation.userId = userId;

            if (userInformation.uid) {
                await userInformationCollection.doc(userInformation.uid).set(userInformation);
            }
            else {
                await userInformationCollection.add(userInformation);
            }
        },
        async fetchHomePage({ state }) {
            try {
                let home_page_query_url = "pages/?type=home.HomePage&fields=featured_articles,magazine_featured_articles,shop_tiles,image_url,shop_image,shop_link";
                let response = await axios.get(`${state.apiUrl}`+home_page_query_url);
                this.commit('setHomePageInfo', response.data.items[0]);
            }
            catch (error) {
                this.commit('setHomePageInfo', []);
            }
        },
        async fetchCategories({ state }) {
            try {
                if (state.categories != null && state.categories._lastUpdate) {
                    let currentTime = Date.now()
                    let ageInSeconds = (currentTime - state.categories._lastUpdate) / 1000;
                    if (ageInSeconds < SECONDS_PER_DAY) { return; }
                }
                let categories_query_url = "categories/?order=sortOrder";
                let response = await axios.get(`${state.apiUrl}`+categories_query_url);
                response.data._lastUpdate = Date.now();
                this.commit('setCategories', response.data);
            }
            catch (error) {
                this.commit('setCategories', []);
            }
        },
        async fetchSportsTypes({ state }) {
            try {
                if (state.sportsTypes != null && state.sportsTypes._lastUpdate) {
                    let currentTime = Date.now()
                    let ageInSeconds = (currentTime - state.sportsTypes._lastUpdate) / 1000;
                    if (ageInSeconds < SECONDS_PER_DAY) { return; }
                }
                let sports_types_query_url = "sportsTypes/?limit=100";
                let response = await axios.get(`${state.apiUrl}`+sports_types_query_url);
                let sportsTypes = response.data.items;
                sportsTypes.sort((a,b) => {
                    let res = a.sort_order - b.sort_order;
                    if (res != 0) return res;
                    return a.name.localeCompare(b.name);
                });
                this.commit('setSportsTypes', {items: sportsTypes, _lastUpdate: Date.now()});
            }
            catch (error) {
                this.commit('setSportsTypes', []);
            }
        },
        async fetchEquipmentList({ state }) {
            if (state.equipmentList != null && state.equipmentList._lastUpdate) {
                let currentTime = Date.now()
                let ageInSeconds = (currentTime - state.equipmentList._lastUpdate) / 1000;
                if (ageInSeconds < SECONDS_PER_DAY) { return; }
            }
            try {
                let categories_query_url = "equipment/";
                let response = await axios.get(`${state.apiUrl}`+categories_query_url);
                response.data.items.forEach(el => el.checked = false);
                response.data._lastUpdate = Date.now();
                this.commit('setEquipmentList', response.data);
            }
            catch (error) {
                this.commit('setEquipmentList', []);
            }
        },
        async fetchArticleCategories({ state }) {
            if (state.articleCategories != null && state.articleCategories._lastUpdate) {
                let currentTime = Date.now()
                let ageInSeconds = (currentTime - state.articleCategories._lastUpdate) / 1000;
                if (ageInSeconds < SECONDS_PER_DAY) { return; }
            }
            try {
                let article_categories_query_url = "articleCategories/";
                let response = await axios.get(`${state.apiUrl}`+article_categories_query_url);
                response.data._lastUpdate = Date.now();
                this.commit('setArticleCategories', response.data);
            }
            catch (error) {
                this.commit('setArticleCategories', []);
            }
        },
        async fetchMediaTypes({ state }) {
            try {
                if (state.articleMediaTypes != null && state.articleMediaTypes._lastUpdate) {
                    let currentTime = Date.now()
                    let ageInSeconds = (currentTime - state.articleMediaTypes._lastUpdate) / 1000;
                    if (ageInSeconds < SECONDS_PER_DAY) { return; }
                }
                let media_types_query_url = "mediaTypes/";
                let response = await axios.get(`${state.apiUrl}`+media_types_query_url);
                response.data._lastUpdate = Date.now();
                this.commit('setArticleMediaTypes', response.data);
            }
            catch (error) {
                this.commit('setArticleMediaTypes', []);
            }
        },
        async fetchCoaches({ state }) {
            try {
                if (state.coaches != null && state.coaches._lastUpdate) {
                    let currentTime = Date.now()
                    let ageInSeconds = (currentTime - state.coaches._lastUpdate) / 1000;
                    if (ageInSeconds < 300) { return; }
                }
                let coaches_query_url = "coaches/";
                let response = await axios.get(`${state.apiUrl}`+coaches_query_url);
                response.data._lastUpdate = Date.now();
                this.commit('setCoaches', response.data);
            }
            catch (error) {
                this.commit('setCoaches', []);
            }
        },
        async fetchChallenges({ state, commit }) {
            try {
                if (state.challenges != null && state.challenges._lastUpdate) {
                    let currentTime = Date.now()
                    let ageInSeconds = (currentTime - state.challenges._lastUpdate) / 1000;
                    if (ageInSeconds < 300) { return; }
                }
                let query = {
                    type: "fitnessplan.FitnessPlanPage",
                    fields: "title,description,image_url,slides,equipment,difficulty,badge,motivationtexts",
                    limit: 1000,
                    order: "-id"};
                let challenges_url = "pages/"
                let response = await axios.get(`${state.apiUrl}`+challenges_url, {
                    params: query
                });
                response.data._lastUpdate = Date.now();
                commit('setChallenges', response.data);
            } catch (error) {
                commit('setChallenges', []);
            }
        },
        async fetchWorkouts({ state, commit }) {
            try {
                if (state.workouts != null && state.workouts._lastUpdate) {
                    let currentTime = Date.now()
                    let ageInSeconds = (currentTime - state.workouts._lastUpdate) / 1000;
                    if (ageInSeconds < 300) { return; }
                }
                let query = {
                    type: "workout.WorkoutPage",
                    fields: "title,intro,go_live_at,coach,duration,difficulty,preview_image_url,square_tile_image_url,requires_equipment,equipment_list,category_list,premium_content,badge,workout_type,sports_types,hide_from_overview",
                    limit: 1000,
                    order: "-go_live_at"};
                let workouts_url = "pages/"
                let response = await axios.get(`${state.apiUrl}`+workouts_url, {
                    params: query
                });
                response.data._lastUpdate = Date.now();
                commit('setWorkouts', response.data);
            } catch (error) {
                commit('setWorkouts', []);
            }
        },
        async fetchArticles({ state, commit }) {
            try {
                if (state.articles != null && state.articles._lastUpdate) {
                    let currentTime = Date.now()
                    let ageInSeconds = (currentTime - state.articles._lastUpdate) / 1000;
                    if (ageInSeconds < 300) { return; }
                }
                let query = {
                    type: "blog.blogPage",
                    fields: "title,intro,date,go_live_at,author,main_image_url,series_subtitle,home_tile_image_url,category_names,categories,media_type_names,media_types,coach,premium_content,readtime,sports_types,tags",
                    limit: 1000,
                    hide_article: false,
                    order: "-go_live_at"};
                let blog_url = "pages/"
                let response = await axios.get(`${state.apiUrl}`+blog_url, {
                    params: query
                });
                response.data._lastUpdate = Date.now();
                commit('setArticles', response.data);
            } catch (error) {
                commit('setArticles', []);
            }
        },
        async searchArticlesByTags({ state }, {search_tags}) {
            try {
                let query = {
                    type: "blog.blogPage",
                    tags: search_tags,
                    fields: "title,intro,date,go_live_at,author,main_image_url,series_subtitle,home_tile_image_url,category_names,categories,media_type_names,media_types,coach,premium_content,readtime,sports_types,tags",
                    limit: 1000,
                    order: "-go_live_at"};
                let blog_url = "pages/"
                let response = await axios.get(`${state.apiUrl}`+blog_url, {
                    params: query
                });
                return response.data;
            } catch (error) {
                return [];
            }
        },
        async searchArticlesByInput({ state }, {search_word}) {
            try {
                let query = {
                    type: "blog.blogPage",
                    search: search_word,
                    search_operator: "and",
                    fields: "title,intro,date,author,main_image_url,series_subtitle,home_tile_image_url,category_names,categories,media_type_names,media_types,coach,premium_content,readtime,sports_types,tags",
                    limit: 1000,
                    //order: "-date"
                };
                let blog_url = "pages/"
                let response = await axios.get(`${state.apiUrl}`+ blog_url, {
                    params: query
                });
                return response.data;
            } catch (error) {
                return [];
            }
        },
        /**
         * Paginated magazine articles (Wagtail offset/limit).
         * Optional search + categories (OR). Used by /articles infinite scroll.
         *
         * Note: Wagtail cannot combine `search` with `hide_article` or `categories`
         * (fields not indexed). Callers must apply category filters client-side when searching.
         */
        async fetchArticlesPage({ state }, { offset = 0, limit = 12, search = '', categoryIds = [] } = {}) {
            const ARTICLE_LIST_FIELDS =
                "title,intro,date,go_live_at,author,main_image_url,series_subtitle,home_tile_image_url,category_names,categories,media_type_names,media_types,coach,premium_content,readtime,sports_types,tags";

            try {
                const isSearch = !!(search && search.length >= 3);
                const query = {
                    type: "blog.blogPage",
                    fields: ARTICLE_LIST_FIELDS,
                    limit,
                    offset,
                };

                if (isSearch) {
                    query.search = search;
                    query.search_operator = "and";
                } else {
                    query.hide_article = false;
                    query.order = "-go_live_at";
                    if (categoryIds && categoryIds.length > 0) {
                        query.categories = categoryIds;
                    }
                }

                // Wagtail expects categories=1&categories=2 (not categories[])
                const paramsSerializer = (params) => {
                    const parts = [];
                    Object.keys(params).forEach((key) => {
                        const val = params[key];
                        if (val === undefined || val === null) return;
                        if (Array.isArray(val)) {
                            val.forEach((item) => {
                                parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
                            });
                        } else {
                            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
                        }
                    });
                    return parts.join("&");
                };

                const response = await axios.get(`${state.apiUrl}pages/`, {
                    params: query,
                    paramsSerializer,
                });

                const data = response.data || {};
                const items = data.items || [];
                const totalCount = (data.meta && data.meta.total_count != null)
                    ? data.meta.total_count
                    : items.length;

                return {
                    items,
                    totalCount,
                    offset,
                    limit,
                };
            } catch (error) {
                return {
                    items: [],
                    totalCount: 0,
                    offset,
                    limit,
                };
            }
        },
        async fetchExercises({ state, commit }) {
            try {
                if (state.exercises != null && state.exercises._lastUpdate) {
                    let currentTime = Date.now()
                    let ageInSeconds = (currentTime - state.exercises._lastUpdate) / 1000;
                    if (ageInSeconds < SECONDS_PER_DAY) { return; }
                }
                let query = {
                    type: "exercise.ExercisePage",
                    fields: "categories,requires_equipment,equipment,video_file,video_file_hq,hints,preview_image_url,square_preview_image_url,premium_content,mez,complementary_exercise,warmup",
                    limit: 1000
                };
                let exercise_url = "pages/"
                let response = await axios.get(`${state.apiUrl}`+exercise_url, {
                    params: query
                });
                response.data._lastUpdate = Date.now();
                commit('setExercises', response.data);
            } catch (error) {
                commit('setExercises', []);
            }
        },
        async fetchPlaylists({ state, commit }) {
            if (state.playlists != null && state.playlists._lastUpdate) {
                let currentTime = Date.now()
                let ageInSeconds = (currentTime - state.playlists._lastUpdate) / 1000;
                if (ageInSeconds < 300) { return; }
            }
            try {
                let query = {
                    type: "exercise.PlaylistPage",
                    fields: "title,intro,go_live_at,image_url,square_tile_image_url,coach,difficulty,duration,requires_equipment,equipment_list,category_list,premium_content,sports_types,hide_from_overview",
                    limit: 1000,
                    order: "-go_live_at"}
                let playlists_url = "pages/"
                let response = await axios.get(`${state.apiUrl}`+playlists_url, {
                    params: query
                });
                response.data._lastUpdate = Date.now();
                commit('setPlaylists', response.data);
            } catch (error) {
                commit('setPlaylists', []);
            }
        },
        async triggerUserVerification({ commit }, { email }) {
            email = email.toLowerCase().trim();
            let formData = new FormData();
            formData.append('email', email);

            try {
                await axios.post('https://apphelper.sportlerplus.com/verifyUser',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                );
                commit('setUserEmailVerified', true);
            } catch (error) {
                // Backend uses first_or_404(): no pending verification row is normal
                // (older accounts, social login, already-processed emails).
                // Mark locally so Home does not retry on every visit / spam Sentry.
                if (error.response && error.response.status === 404) {
                    commit('setUserEmailVerified', true);
                    return;
                }
                console.warn('triggerUserVerification failed', error);
            }
        },
        /* eslint-disable no-unused-vars */
        /* redeemCode usually called from landing page, user not logged in */
        async redeemCode({state}, { email, code }) {
            let d = new Date();
            code = code.toUpperCase().trim();
            email = email.toLowerCase().trim();
            let valid = false;

            let formData = new FormData();
            formData.append('code', code);

            await axios.post('https://apphelper.sportlerplus.com/redeemCode',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then((res) => {
                let code_information = res.data;
                if (code_information.duration) {
                    valid = true;
                    let duration = code_information.duration;
                    if (duration.endsWith("m")) {
                        d.setMonth(d.getMonth() + parseInt(duration));
                    }
                    else if (duration.endsWith("d")) {
                        d.setDate(d.getDate() + parseInt(duration));
                    }
                }
            });

            if (!valid) return {};

            var result = [];
            var query = premiumPurchasesCollection.where("email", "==", email);
            await query.limit(1).get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    // doc.data() is never undefined for query doc snapshots
                    result.push(Object.assign({ uid: doc.id }, doc.data()));
                });
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
            });
            let doc;
            if (result.length == 0) {
                doc = {email: email, code: code, validTo: d, conversion: "promo"};
                await premiumPurchasesCollection.add(doc);
            }
            else {
                doc = result[0];
                doc.validTo = d;
                doc.code = code;
                await premiumPurchasesCollection.doc(doc.uid).set(doc);
            }
            return doc;
        },
        async activatePurchase({state, commit}, { email, code, transactionId }) {
            let d = new Date();
            email = email.toLowerCase();
            if (code === "com.sportplatzmedia.sportlerplus.subscription12m") {
                d.setMonth(d.getMonth() + 13);
            }
            else if (code == "com.sportplatzmedia.sportlerplus.subscription3m") {
                d.setMonth(d.getMonth() + 3);
            }
            else {
                return {};
            }

            var result = [];
            var query = premiumPurchasesCollection.where("email", "==", email);
            await query.limit(1).get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    // doc.data() is never undefined for query doc snapshots
                    result.push(Object.assign({ uid: doc.id }, doc.data()));
                });
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
            });
            let doc;
            if (result.length == 0) {
                doc = {email: email, code: code, validTo: d, transactionId: transactionId, conversion: "direct"};
                await premiumPurchasesCollection.add(doc);
            }
            else {
                doc = result[0];
                doc.validTo = d;
                doc.code = code;
                doc.transactionId = transactionId;
                await premiumPurchasesCollection.doc(doc.uid).set(doc);
            }
            commit('setPremiumStatus', doc);
            return doc;
        },
        async fetchPremiumStatus({commit}, {email}) {
            let currentDate = new Date();
            var result = [];
            email = email.toLowerCase();
            
            var query = premiumPurchasesCollection.where("email", "==", email);
            await query.get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    // doc.data() is never undefined for query doc snapshots
                    let data = doc.data()
                    let endDate = data.validTo.toDate();
                    if (endDate > currentDate) {
                        result.push(data)
                    }
                });
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
            });
            
            commit('setPremiumStatus', result.length > 0 ? result[0] : []);
        },
        userRegister({ state, commit }, { email, password, name }) {
        firebase
            .auth()
            .createUserWithEmailAndPassword(email, password)
            .then(user => {
                commit('setUser', user);
                commit('setIsAuthenticated', true);
                try {
                    let fbUser = firebase.auth().currentUser;
                    fbUser.updateProfile({
                        displayName: name,
                    });
                    fbUser.sendEmailVerification();

                    let onboardingData = state.onboardingData;
                    onboardingData.userId = fbUser.uid;
                    userInformationCollection.add(onboardingData);

                    navigateTo("/welcome"); 
                }
                catch(error) {
                    console.log("Error storing onboarding data: " + error);
                }
            })
            .catch((error) => {
                console.log("error registering user");
                var errorCode = error.code;
                var errorMessage = error.message;
                console.log("code: " + errorCode);
                console.log("message: " +errorMessage);
                if (errorCode == "auth/email-already-in-use") {
                    alert("Diese Email-Adresse wird bereits für ein anderes SportlerPlus Konto verwendet.")
                }
                else {
                    alert(errorMessage);
                }
                commit('setUser', null);
                commit('setIsAuthenticated', false);
            });
        },
        triggerFitnessPlanMigration({ state }) {
            const userId = state.user && state.user.user && state.user.user.uid;
            if (userId) {
                ensureMigrated(userId);
            }
        },
        userLogin({ commit, dispatch }, { email, password, redirect }) {
            firebase.auth().signInWithEmailAndPassword(email, password)
            .then(user => {
                commit('setUser', user);
                commit('setIsAuthenticated', true);
                this.dispatch('fetchPremiumStatus', {email: user.user.email});
                dispatch('triggerFitnessPlanMigration');
                navigateTo(redirect || "/");
            })
            .catch((error) => {
                var errorCode = error.code;
                var errorMessage = error.message;
                // The email of the user's account used.
                console.log("login error:");
                console.log(errorCode);
                console.log(errorMessage);
                alert("Fehler beim Anmelden, Benutzername oder -kennwort falsch.")
                commit('setUser', null);
                commit('setIsAuthenticated', false);
            });
        },
        userSignOut({ commit }) {
            window._spStatus = {};
            firebase.auth().signOut()
            .then(() => {
                commit('setUser', null);
                commit('setIsAuthenticated', false);
                navigateTo('/');
            })
            .catch(() => {
                commit('setUser', null);
                commit('setIsAuthenticated', false);
                navigateTo('/');
            });
        },
        socialLogin({ commit, dispatch }, { providerString, redirect }) {
            let provider = null;
            if (providerString === "google")
                provider = new firebase.auth.GoogleAuthProvider();
            else if (providerString === "facebook")
                provider = new firebase.auth.FacebookAuthProvider();
            else if (providerString === "apple") {
                provider = new firebase.auth.OAuthProvider('apple.com');
                provider.addScope('email');
                provider.addScope('name');
            }
            return firebase.auth().signInWithPopup(provider).then((user) => {
                commit('setUser', user);
                commit('setIsAuthenticated', true);
                this.dispatch('fetchPremiumStatus', {email: user.user.email});
                dispatch('triggerFitnessPlanMigration');
                navigateTo(redirect || "/");
            }).catch((error) => {
                var errorCode = error.code;
                var errorMessage = error.message;
                // The email of the user's account used.
                var email = error.email;
                // The firebase.auth.AuthCredential type that was used.
                var credential = error.credential;
                console.log("login error:");
                console.log(errorCode);
                console.log(errorMessage);
                alert(errorMessage);
                console.log(email);
                console.log(credential);
                commit('setUser', null);
                commit('setIsAuthenticated', false);
                throw error;
            });
        },
        async likeArticle( {state}, article) {
            const userId = state.user.user.uid;
            const docId = `${userId}_${article.id}`;

            // check if user has liked article
            const doc = await favouritesCollection.doc(docId).get();
            if (doc.exists) { return }

            // create post
            await favouritesCollection.doc(docId).set({
                articleId: article.id,
                userId: userId,
                type: 'blog.BlogPage',
                title: article.title,
                subtitle: "Magazin - " + article.category_names,
            });
        },
        async likeCategory( {state}, category) {
            const userId = state.user.user.uid;
            const docId = `${userId}_cat_${category.id}`;

            // check if user has liked category already
            const doc = await favouritesCollection.doc(docId).get();
            if (doc.exists) { return }

            // create post
            await favouritesCollection.doc(docId).set({
                categoryId: category.id,
                userId: userId,
                type: 'Category',
                title: category.name,
                subtitle:  category.name + " Mix",
            });
        },
        removeCategoryLike ( {state}, category) {
            const userId = state.user.user.uid;
            const docId = `${userId}_cat_${category.id}`;
            favouritesCollection.doc(docId).delete();
        },
        async checkCategoryFavourite( {state}, category) {
            const userId = state.user.user.uid;
            const docId = `${userId}_cat_${category.id}`;

            // check if user has liked article
            const doc = await favouritesCollection.doc(docId).get();
            if (doc.exists) { return true; }
            return false;
        },
        async likePlaylist( {state}, playlist) {
            const userId = state.user.user.uid;
            const docId = `${userId}_${playlist.id}`;

            // check if user has liked playlist
            const doc = await favouritesCollection.doc(docId).get();
            if (doc.exists) { return }

            // create post
            await favouritesCollection.doc(docId).set({
                articleId: playlist.id,
                userId: userId,
                type: 'exercise.Playlist',
                title: playlist.title,
                subtitle: "Playlist - " + playlist.exercises.length + " Übungen",
            });
        },
        async likeWorkout( {state}, workout) {
            const userId = state.user.user.uid;
            const docId = `${userId}_${workout.id}`;

            // check if user has liked article
            const doc = await favouritesCollection.doc(docId).get();
            if (doc.exists) { return }

            let coach, subtitle;
            if (workout.coach && state.coaches && state.coaches.items) {
                coach = state.coaches.items.find(c => c.id == workout.coach.id);
            }
            if (coach != null) {
                subtitle = "Workout - " + coach.name + " - " + workout.duration + " Min."
            }
            else {
                subtitle = "Workout - " + workout.duration + " Min.";
            }
            // create post
            await favouritesCollection.doc(docId).set({
                articleId: workout.id,
                userId: userId,
                type: 'workout.WorkoutPage',
                title: workout.title,
                subtitle: subtitle,
            });
        },
        async checkArticleFavourite( {state}, articleId) {
            const userId = state.user.user.uid;
            const docId = `${userId}_${articleId}`;

            // check if user has liked article
            const doc = await favouritesCollection.doc(docId).get();
            if (doc.exists) { return true; }
            return false;
        },
        async fetchAllFavourites( {state} ) {
            const userId = state.user.user.uid;
            var result = [];
            var query = favouritesCollection.where("userId", "==", userId);
            query.get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                // doc.data() is never undefined for query doc snapshots
                result.push(Object.assign({ uid: doc.id }, doc.data()));
                });
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
            });
            return result;
        },
        removeArticleLike ( {state}, article) {
            const userId = state.user.user.uid;
            const docId = `${userId}_${article.id}`;
            favouritesCollection.doc(docId).delete();
        },
        setDeviceToken( { state, commit }, { token, system, installationId } ) {
            if (!state.isAuthenticated || (installationId === state.installationId)) { return; }
            const userId = state.user.user.uid;
            commit('setDeviceToken', token);
            commit('setOperatingSystem', system);
            commit('setInstallationId', installationId);
            devicesCollection.doc(userId).set({userId: userId, fcmToken: token, system: system, installationId: installationId})
                .catch((error) => console.warn('setDeviceToken failed', error));
        },
        transferReceiptData( { state, commit }, { receiptData, system } ) {
            if (!state.isAuthenticated || (receiptData === state.receiptData)) { return; }
            const userId = state.user.user.uid;
            commit('setReceiptData', receiptData);
            receiptCollection.doc(userId).set({receiptData: receiptData, system: system})
                .catch((error) => console.warn('transferReceiptData failed', error));
        },
        unrollCalendar({ state }) {
            // VERALTET: Verwende getFitnessplanCalendar Cloud Function!
            console.warn('unrollCalendar is deprecated - use getFitnessplanCalendar Cloud Function instead');
            return [];
        },
        /* scope may be 'week', 'month', 'year', 'entire' */
        async statisticsData({ state }, { startDate, scope }) {
            const userId = state.user && state.user.user && state.user.user.uid;
            if (!userId) {
                console.warn('No userId available in store for statistics');
                return getEmptyStatistics();
            }
            
            // Cloud Function verwenden (mit userId Parameter)
            try {
                const startDateParam = startDate ? startDate.format('YYYY-MM-DD') : null;
                const statistics = await getStatistics(userId, {
                    scope,
                    startDate: startDateParam,
                });
                console.log('Store: Statistics loaded from server:', {
                    totalWorkouts: statistics.totalCount,
                    totalDuration: statistics.totalDuration,
                    dataPoints: statistics.data ? statistics.data.length : 0
                });
                
                return statistics;
                
            } catch (error) {
                console.error('Store: Error fetching statistics from Cloud Function:', error);
                throw error; // Keine Fallbacks - Cloud Function muss funktionieren
            }
        }
    },
    modules: {},
    getters: {
        getSoundEnabled(state) {
            return state.soundEnabled;
        },
        isAuthenticated(state) {
            return state.user !== null && state.user !== undefined;
        },
        getArticles(state) {
            return listItems(state.articles);
        },
        getFitnessplan(state) {
            if (state.fitnessPlan !== null) {
                return state.fitnessPlan;
            }
            return null;
        },
        getFeaturedArticles(state) {
            if (state.homePageInfo !== null) {
                return state.homePageInfo.featured_articles;
            }
        },
        getFeaturedMagazineArticles(state) {
            if (state.homePageInfo !== null) {
                return state.homePageInfo.magazine_featured_articles;
            }
        },
        getHomePageInfo(state) {
            return state.homePageInfo;
        },
        getWorkouts(state) {
            return listItems(state.workouts);
        },
        getChallenges(state) {
            return listItems(state.challenges);
        },
        getPlaylists(state) {
            return listItems(state.playlists);
        },
        getExercises(state) {
            return listItems(state.exercises);
        },
        getCategories(state) {
            return listItems(state.categories);
        },
        getSportsTypes(state) {
            return listItems(state.sportsTypes);
        },
        getEquipmentList(state) {
            return listItems(state.equipmentList);
        },
        getCoaches(state) {
            return listItems(state.coaches);
        },
        getApiUrl(state) {
            return state.apiUrl;
        },
        getTemporaryPlaylist(state) {
            return state.temporaryPlaylist;
        },
        getWorkoutSource(state) {
            return state.workoutSource;
        },
        getArticleMediaTypes(state) {
            if (state.articleMediaTypes) {
                return state.articleMediaTypes.items;
            }
            return null;
        },
        getArticleCategories(state) {
            if (state.articleCategories && state.articleCategories.items) {
                return state.articleCategories.items.filter(cat => cat.active);
            }
            return null;
        },
        getOnboardingData(state) {
            return state.onboardingData;
        },
        getPremiumStatus(state) {
            var email = "unknown@email.address";
            if (state.user && state.user.user) {
                email = state.user.user.email;
            }
            // return standard valid premium status until 1.1.2030
            return {
                "code": "DATE-WITH-IKEA",
                "email": email,
                "validTo": {
                    nanoseconds: 0,
                    seconds: 1893455999
                },
            }
            /*
            if (state.premiumStatus && Object.keys(state.premiumStatus).length !== 0) {
                let currentDateSeconds = new Date().getTime() / 1000;
                let endDate = state.premiumStatus.validTo.seconds;
                if (endDate > currentDateSeconds) {
                    return state.premiumStatus;
                }
            }
            return {}
            */
        },
        getUserEquipment(state) {
            return state.userEquipment;
        },
        getReadArticleList(state) {
            return state.readArticleList;
        },
        getDisplayedMotivationTextList(state) {
            return state.displayedMotivationTextList;
        },
        getSelectedFitnessPlanActivity(state) {
            return state.selectedFitnessPlanActivity;
        },
        getRecentFitnessPlanActivities(state) {
            return state.recentFitnessPlanActivities;
        },
        getRecentTrainingActivities(state) {
            return state.recentTrainingActivities;
        },
        getWorkoutIntensities(state) {
            return state.workoutIntensities;
        },
        getVersion(state) {
            return version;
        },
        getInstallationId(state) {
            return state.installationId;
        },
        getDeviceToken(state) {
            return state.deviceToken;
        },
        getUserEmailVerified(state) {
            return state.userEmailVerified;
        }
    },
    plugins: [vuexLocal.plugin]
})
